import React, { useState, useEffect } from 'react'
import { apvForecastingBanner } from '@revbox/localization'

const BANNER_CLOSED_KEY = 'features_banner_closed'
const BANNER_EXPIRY_DATE = '2025-12-15' 

const ApvForecastingBanner = ({ language = 'EN' }) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const closed = localStorage.getItem(BANNER_CLOSED_KEY)
    if (closed === 'true') return

    const now = new Date()
    const expiryDate = new Date(BANNER_EXPIRY_DATE)

    if (now < expiryDate) {
      setVisible(true)
    } else {
      localStorage.removeItem(BANNER_CLOSED_KEY)
    }
  }, [])

  const handleClose = () => {
    localStorage.setItem(BANNER_CLOSED_KEY, 'true')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      className="alert alert-success d-flex align-items-start justify-content-between p-3 shadow-sm"
      role="alert"
    >
      <div className="flex-grow-1">
        <strong className="d-flex align-items-center mb-2 fs-6">
          <i className="ri-information-line me-2 fs-5 text-success"></i>
          {apvForecastingBanner[language].content.title}
        </strong>
        <ul className="mb-0 ps-3">
          {apvForecastingBanner[language].content.features.map((feature, i) => (
            <li key={i} className="small lh-sm mb-1">
              {feature}
            </li>
          ))}
        </ul>
      </div>

      <button
        type="button"
        className="btn-close ms-3 mt-1"
        aria-label="Close alert"
        onClick={handleClose}
      ></button>
    </div>
  )
}

export default ApvForecastingBanner
